// Cloudinary CDN helpers. Assets are public, so URLs are built client-side.
const CLOUD_NAME = 'rp2zwlm2';
const BASE = `https://res.cloudinary.com/${CLOUD_NAME}`;

// Video stream: q_auto lets Cloudinary pick the smallest file with no visible quality loss.
export const videoUrl = ({ publicId, version }, transform = 'q_auto') =>
  `${BASE}/video/upload/${transform}/v${version}/${publicId}.mp4`;

// Poster frame grabbed from the video itself (so_ = start offset in seconds).
export const videoPosterUrl = ({ publicId, version, posterOffset = 2 }, width = 1600) =>
  `${BASE}/video/upload/so_${posterOffset},w_${width},c_limit,q_auto,f_auto/v${version}/${publicId}.jpg`;
